import { useEffect } from "react";
import { useRouteError } from "react-router";
import GlobalError from "@/components/layout/global-error";
import { describeError, trackAppEvent } from "@/util/analytics";

export default function GlobalErrorBoundary() {
  const error = useRouteError();

  // Route errors are otherwise invisible in reporting: the page-view event has
  // already fired for the route that then failed to render, so Adobe sees a
  // normal visit. Report the failure separately rather than inferring it.
  useEffect(() => {
    trackAppEvent({
      eventName: "app_error",
      eventAction: "failure",
      errorMessage: describeError(error),
      path: window.location.pathname,
    });
  }, [error]);

  return <GlobalError error={error} />;
}
